import { useMemo } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentProject } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import SpacePath from "components/SpacePath";
import { IntentProjectResourcesSuggestions } from "shared/IntentProject/useSearchIntentResourcesOperationsSuggestions/constants";

import useCellFilterAction from "../useCellFilterAction";

const IntentProjectsTableSpaceCell = ({
  item: intentProject,
  ...cellProps
}: TableSimpleCellProps<IntentProject>) => {
  const spaceFilterAction = useCellFilterAction({
    filterName: IntentProjectResourcesSuggestions.SPACE,
    filterValue: intentProject.space.id,
    spaceCell: true,
  });

  const actions = useMemo(() => [spaceFilterAction], [spaceFilterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <SpacePath spaceId={intentProject.space.id} fallbackName={intentProject.space.name} />
    </TableSimpleCell>
  );
};

export default IntentProjectsTableSpaceCell;
